export const guruji = "https://ik.imagekit.io/hgfugmm0dbi/Vysion_Website_Assets/mmiio27342_k2FlNtcmV.png?updatedAt=1713518381279"